import { render, staticRenderFns } from "./AuditLogTable.vue?vue&type=template&id=cbab42f4"
import script from "./AuditLogTable.vue?vue&type=script&lang=js"
export * from "./AuditLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports